import { isProductConversion } from './guards.js';
import { STORAGE_KEY, STORAGE_KEY_LEGACY, STORAGE_ITEM_LIFETIME, } from './consts.js';
export const storage = {
    get: () => {
        const data = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
        const { validEntries, invalidEntries } = validateAndPartitionStore(data);
        if (validEntries.length > 0) {
            const validStore = Object.fromEntries(validEntries);
            if (invalidEntries.length > 0) {
                // override storage to remove invalid entries
                storage.set(validStore);
            }
            return validStore;
        }
        else if (invalidEntries.length > 0) {
            // wipe the storage completely when there are **only** invalid entries
            storage.clear();
        }
        // storage is empty
        return null;
    },
    set: (store) => {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(store));
    },
    clear: () => {
        localStorage.removeItem(STORAGE_KEY);
    },
    getById: (id) => {
        return storage.get()?.[id] || null;
    },
    setById: (id, update) => {
        const store = storage.get();
        const productConversion = update(store?.[id] || null);
        localStorage.setItem(STORAGE_KEY, JSON.stringify({
            ...store,
            [id]: productConversion,
        }));
        // To have a smooth upgrade path, we store the old format aswell.
        // This way consumers that are using an old library version can still read the data.
        const legacyStore = JSON.parse(localStorage.getItem(STORAGE_KEY_LEGACY) || 'null');
        localStorage.setItem(STORAGE_KEY_LEGACY, JSON.stringify({
            ...legacyStore,
            [id]: mapProductConversionToLegacyFormat(productConversion),
        }));
    },
};
const validateAndPartitionStore = (store) => {
    const now = Date.now();
    return Object.entries(store || {}).reduce((result, [key, value]) => {
        if (isProductConversion(value) &&
            now - value.ts < STORAGE_ITEM_LIFETIME) {
            result.validEntries.push([key, value]);
        }
        else {
            result.invalidEntries.push([key, value]);
        }
        return result;
    }, { validEntries: [], invalidEntries: [] });
};
const mapProductConversionToLegacyFormat = (productConversion) => {
    return {
        ts: productConversion.ts,
        conversionUrl: [
            productConversion.conversions['hotel-listing']?.trackingUrl,
            productConversion.conversions['offer-listing']?.trackingUrl,
        ].filter(Boolean),
        journeys: productConversion.journeys,
    };
};
//# sourceMappingURL=storage.js.map